import { LOB } from "../../../api/routes";

export const lobName: Record<LOB, string | undefined> = {
  builders_risk: "Builder's Risk",
  property: "Property",
  property_renewal: "Renewals",
  cat: "CAT",
};

export function perLOB<T>(map: { [lob in LOB]?: T }): {
  [lob: string]: T | undefined;
} {
  return map;
}
